import ReadingDrawer from './ReadingDrawer';
export default ReadingDrawer;
